import React from 'react';
import { Grid } from '@mui/material';

import PhotoStatusContainer from '../containers/photo/PhotoStatusContainer';
import NewPage from '../components/NewPage';
import { getManagerMode } from '../common/util';

const PhotoPage = () => {
  const bManagerMode = getManagerMode();

  return (
    <NewPage title="포토">
      <Grid item xs={12}>
        <PhotoStatusContainer bManagerMode={bManagerMode} />
      </Grid>
    </NewPage>
  );
};

export default PhotoPage;
